import { render, staticRenderFns } from "./AllNotes.vue?vue&type=template&id=a57f9a88"
import script from "./AllNotes.vue?vue&type=script&lang=js"
export * from "./AllNotes.vue?vue&type=script&lang=js"
import style0 from "./AllNotes.vue?vue&type=style&index=0&id=a57f9a88&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a57f9a88')) {
      api.createRecord('a57f9a88', component.options)
    } else {
      api.reload('a57f9a88', component.options)
    }
    module.hot.accept("./AllNotes.vue?vue&type=template&id=a57f9a88", function () {
      api.rerender('a57f9a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/AllNotes.vue"
export default component.exports